import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { vendorEndpoint } from "../../../../api/endpoints";
import useSWR from "swr";
import { fetcher } from "../../../../services/fetcher";
import { TextInput, Textarea, Grid, Group, Button, Select } from "@mantine/core";

const AddEditBenefits = ({ onSubmit, initialData, isSubmitting }) => {
  const { register, handleSubmit, setValue, watch } = useForm();
  const { data: providers } = useSWR(vendorEndpoint, fetcher);

  useEffect(() => {
    if (initialData) {
      setValue("id", initialData.id);
      setValue("code", initialData.code);
      setValue("name", initialData.name);
      setValue("description", initialData.description);
      setValue("providers", initialData.providers || []);
    }
  }, [initialData, setValue]);

  const selectedProvider = watch("providers");

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid cols={2} grow>
        <Grid.Col span={6}>
          <TextInput
            label="Code"
            placeholder="Create benefit code"
            {...register("code", { required: true })}
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <TextInput
            label="Name"
            placeholder="Enter benefit name"
            {...register("name", { required: true })}
          />
        </Grid.Col>

        <Grid.Col span={6}>
          <Select
            label="Policy Provider"
            placeholder="Select policy provider"
            data={
              providers?.map(provider => ({
                value: String(provider.id),
                label: provider.name
              })) || []
            }
            value={selectedProvider} 
            onChange={(value) => setValue("providers", value ? [value] : [])} 
          />

        </Grid.Col>

        <Grid.Col>
          <Textarea
            label="Description"
            placeholder="Enter benefit description"
            {...register("description")}
          />
        </Grid.Col>

        <TextInput type="hidden" {...register("id")} />
      </Grid>

      <Group justify="center">
        <Button
          variant="gradient"
          type="submit"
          mt="xl"
          size="md"
          loading={isSubmitting}
          loaderProps={{ type: "dots" }}
        >
          Submit
        </Button>
      </Group>
    </form>
  );
};

export default AddEditBenefits;
